/**
 * @generated SignedSource<<0b326e4946a45d9936a46c0169e7081d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OriginalEstimateCell$data = {
  readonly id?: string;
  readonly issue: {
    readonly timeTrackingField: {
      readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "OriginalEstimateCell";
};
export type OriginalEstimateCell$key = {
  readonly " $data"?: OriginalEstimateCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "OriginalEstimateCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                }
              ],
              "kind": "FragmentSpread",
              "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraOriginalTimeEstimateField"
};

(node as any).hash = "e2dcb6c43f15d8d0dc58895836e5db15";

export default node;
